import { QuestResponseType } from '../AccountsPayable/AccountsPayable.types';

export enum BoxMovementDateFilter {
  launch,
  conciliation,
}

export enum BoxMovementReportType {
  general,
  planAccount,
}

export enum BoxMovementType {
  general,
  tariffs,
}

export interface QuestBoxMovementRequest {
  responseType: QuestResponseType;
  companiesIds?: string;
  bankAccountIds?: string;
  dateFilter: BoxMovementDateFilter;
  reportType: BoxMovementReportType;
  movementType: BoxMovementType;
  documentTypeIds?: string;
  planAccountIds?: string;
  startDate: string;
  endDate: string;
}

export const REPORT_BOX_MOVEMENT_DATE_FILTER = {
  LAUNCH: BoxMovementDateFilter.launch,
  CONCILIATION: BoxMovementDateFilter.conciliation,
};

export const REPORT_BOX_MOVEMENT_TYPE = {
  GENERAL: BoxMovementType.general,
  TARIFFS: BoxMovementType.tariffs,
};

export const REPORT_BOX_MOVEMENT_REPORT_TYPE = {
  GENERAL: BoxMovementReportType.general,
  PLAN_ACCOUNT: BoxMovementReportType.planAccount,
};
